/**
 * Сборка фронтенда для «О приложении» (этап 5 шаг 4): дата сборки и коммит.
 * Значение подставляет Vite (define в vite.config.ts web-app и telegram-app);
 * в тестах и без подстановки - «сборка для разработки».
 */
declare const __APP_BUILD__: string | undefined

export const APP_BUILD: string = typeof __APP_BUILD__ === 'string' && __APP_BUILD__ ? __APP_BUILD__ : 'сборка для разработки'
